enum AnnouncementTypes {
    GET_USER_ANNOUNCEMENTS = 'GET_USER_ANNOUNCEMENTS',
    GET_USER_ANNOUNCEMENTS_LOADING = 'GET_USER_ANNOUNCEMENTS_LOADING',
    GET_UNREAD_USER_ANNOUNCEMENTS = 'GET_UNREAD_USER_ANNOUNCEMENTS',
    UPDATE_USER_ANNOUNCEMENT = 'UPDATE_USER_ANNOUNCEMENT',
    UPDATE_USER_ANNOUNCEMENT_LOADING = 'UPDATE_USER_ANNOUNCEMENT_LOADING',
    GET_ANNOUNCEMENTS = 'GET_ANNOUNCEMENTS',
    GET_ANNOUNCEMENTS_LOADING = 'GET_ANNOUNCEMENTS_LOADING',
    GET_ANNOUNCEMENTS_ERROR = 'GET_ANNOUNCEMENTS_ERROR',
    UPDATE_ANNOUNCEMENT = 'UPDATE_ANNOUNCEMENT',
    UPDATE_ANNOUNCEMENT_LOADING = 'UPDATE_ANNOUNCEMENT_LOADING',
    CREATE_ANNOUNCEMENT = 'CREATE_ANNOUNCEMENT',
    CREATE_ANNOUNCEMENT_LOADING = 'CREATE_ANNOUNCEMENT_LOADING',
    DELETE_ANNOUNCEMENT = 'DELETE_ANNOUNCEMENT',
}

export type AnnouncementsStates = 'start' | 'draft' | 'scheduled' | 'send_now' | 'sent';

export interface Announcement {
    ID: string;
    created?: number;
    updated?: number;
    companyID: string;
    instanceID: string;
    title: string;
    message?: string;
    messageHTML: string;
    currentState: AnnouncementsStates;
    schedule?: string;
    nextRunAt?: string;
    executionArn?: string;
    routingProfileID?: string;
    agentHierarchy?: string;
    sentByID?: string;
    sentByName?: string;
    createdByID: string;
    createdByName: string;
    lastUpdatedByID: string;
    lastUpdatedByName: string;
    lastSentDate: string;
    relativeExpiry?: string;
    expiry?: number;
}

export interface UserAnnouncement extends Announcement {
    ID: string;
    agentID: string;
    instanceID: string;
    read: number;
    created: number;
    updated: number;
}

export type AnnouncementReport = UserAnnouncement[]

export default AnnouncementTypes;